import React from 'react';
import { Link } from 'react-router-dom';
import { FiInstagram, FiMail } from 'react-icons/fi';
import '../styles/Footer.scss';
import logotext from '../assets/logotext.png'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <div className="footer-logo">
               <img src={logotext} alt="Invits" className="footer-logo" />
            </div>
            <p className="footer-tagline">
              Create beautiful invitations for your next event
            </p>
          </div>
          
          <div className="footer-section">
            <h3>Legal</h3>
            <ul className="footer-links">
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/refunds">Cancellation & Refunds</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Support</h3>
            <ul className="footer-links">
              <li><Link to="/contact">Contact Us</Link></li>
              <li><a href="mailto:support@invits.co">support@invits.co</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="footer-social">
              <a href="https://instagram.com/invitsapp" target="_blank" rel="noopener noreferrer">
                <FiInstagram />
              </a>
              <a href="mailto:hello@invits.co">
                <FiMail />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} INVITS. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;